import {
    SchoolListItem,
    ClassByOrgIdsRequest,
    ClassByOrgIdsResponse,
    AddEnrollmentsTransformRequest,
    AddUserTransformSaveRequest,
    BasicUserInfo,
    OrganizationDTO,
    TransformUserRoleRequest,
    TransformAddUserDTO,
    TransformUserRoleDTO,
    TransformAddEnrollmentDTO,
    TransformAddEnrollmentsGetResponse,
    UpdateTransformAddUserRequest
} from "@beable/roster-backend-client-v1";

import RosterBackendService from "./RosterBackendService";

async function getSchools(siteId: number): Promise<SchoolListItem[] | null> {
    const response = await RosterBackendService.getSchools(siteId);
    if (response.isOk()) {
        return response.value;
    }
    return null;
}
async function getOrgs(siteId: number): Promise<OrganizationDTO[] | null> {
    const response = await RosterBackendService.findAllOrganizations(siteId);

    if (response.isOk()) {
        const allOrgs: OrganizationDTO[] = [];

        for (const o of response.value) {
            allOrgs.push(o.orgInfo);
            for (const child of o.children) {
                allOrgs.push(child.orgInfo);
            }
        }
        return allOrgs;
    }
    return null;
}
async function getUsersAndTransformAddUsers(siteId: number): Promise<BasicUserInfo[] | null> {
    const response = await RosterBackendService.getUsersAndTransformAddUsers(siteId);
    if (response.isOk()) {
        return response.value;
    }
    return null;
}

async function getUsersBySubstring(siteId: number, searchTerm: string): Promise<BasicUserInfo[] | null> {
    const resp = await RosterBackendService.getUsersAndTransformAddUsersBySubstring({ siteId, searchTerm });

    if (resp.isOk() && resp.value) {
        return resp.value;
    }

    return null;
}

async function findActiveClassesbyOrgIds(siteId: number, orgIds: string[]): Promise<ClassByOrgIdsResponse | null> {
    const req: ClassByOrgIdsRequest = {
        siteId,
        orgIds
    };

    const classesResp = await RosterBackendService.findActiveClassesbyOrgIds(req);

    if (classesResp.isOk() && classesResp.value) {
        return classesResp.value;
    }

    return null;
}
async function saveAddEnrollmentsTransformation(req: AddEnrollmentsTransformRequest): Promise<boolean | null> {
    const resp = await RosterBackendService.saveAddEnrollmentsTransformation(req);

    if (resp.isOk() && resp.value) {
        return resp.value;
    }

    return null;
}
async function saveAddUserTransformation(req: AddUserTransformSaveRequest): Promise<boolean | null> {
    const resp = await RosterBackendService.saveAddUserTransformation(req);

    if (resp.isOk() && resp.value) {
        return resp.value;
    }

    return null;
}

async function saveAddUserRoleTransformation(req: TransformUserRoleRequest): Promise<boolean | null> {
    const resp = await RosterBackendService.saveAddUserRoleTransformation(req);

    if (resp.isOk() && resp.value) {
        return resp.value;
    }

    return null;
}

async function getTransformAddUsers(siteId: number): Promise<TransformAddUserDTO[] | null> {
    const resp = await RosterBackendService.transformAddUsersGet(siteId);
    if (resp.isOk() && resp.value) {
        return resp.value;
    }
    return null;
}

async function getTransformAddEnrollments(siteId: number): Promise<TransformAddEnrollmentDTO[] | null> {
    const allEnrollments: TransformAddEnrollmentDTO[] = [];
    let page = 0;
    let hasMoreData = true;
    
    while (hasMoreData) {
        const resp = await RosterBackendService.transformAddEnrollmentsGet(siteId, page);
        
        if (!resp.isOk() || !resp.value) {
            if (page === 0) {
                return null;
            }
            hasMoreData = false;
        } else {
            const data: TransformAddEnrollmentsGetResponse = resp.value;
            
            if (!data.transformAddEnrollments || data.transformAddEnrollments.length === 0) {
                hasMoreData = false;
            } else {
                allEnrollments.push(...data.transformAddEnrollments);
                page++;
            }
        }
    }
    
    return allEnrollments.length > 0 ? allEnrollments : null;
}

async function getTransformUserRoles(siteId: number): Promise<TransformUserRoleDTO[] | null> {
    const resp = await RosterBackendService.transformUserRolesGet(siteId);
    if (resp.isOk() && resp.value) {
        return resp.value;
    }
    return null;
}

async function updateTransformAddUser(req: UpdateTransformAddUserRequest): Promise<boolean | null> {
    const resp = await RosterBackendService.updateTransformAddUser(req);

    if (resp.isOk() && resp.value) {
        return resp.value;
    }

    if (resp.isErr()) {
        console.error('Error updating transform add user:', resp.error.message);
    }

    return null;
}

export default {
    getSchools,
    getOrgs,
    getUsersAndTransformAddUsers,
    findActiveClassesbyOrgIds,
    saveAddEnrollmentsTransformation,
    saveAddUserTransformation,
    saveAddUserRoleTransformation,
    getUsersBySubstring,
    getTransformAddUsers,
    getTransformAddEnrollments,
    getTransformUserRoles,
    updateTransformAddUser
};